import { AbstractControl, Validators } from '@angular/forms';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { notWhitespaceValidator } from '@utility/utility.validators';

export class BaseExpenseFormGroup<
    TControl extends {
        [K in keyof TControl]: AbstractControl<any>;
    } = {},
> extends PersistentFormGroup<
    TControl & {
        requestedAmountInLocalCurrency: PersistentFormControl<string>;
        authorizedAmountInLocalCurrency: PersistentFormControl<string>;
    }
> {
    constructor(controls: TControl) {
        super({
            ...controls,
            requestedAmountInLocalCurrency: new PersistentFormControl<string>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
            authorizedAmountInLocalCurrency: new PersistentFormControl<string>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
        });
    }
}
